import contempInterior from '@/assets/img/users-cases/contemp-interior.webp';
import contempInteriorHow from '@/assets/img/users-cases/contemp-interior-how.webp';
import contempInteriorResult from '@/assets/img/users-cases/contemp-interior-result.webp';

export default {
  slug: 'contemp-interior',
  order: 18,
  title: 'Contemp 3D Interior Tour',
  subtitle: 'Modern interiors shown in clean 3D visualizations',
  tags: ['InteriorDesign', 'Floorplans'],

  images: {
    hero: contempInterior,
    aboutTop: contempInteriorHow,
    aboutBottom: contempInteriorResult,
  },

  howText:
    'We delivered 2D and 3D apartment floor plans along with a scalable interior design concept that can be easily rolled out across multiple units.',

  resultText:
    'These solutions help cut down approval time and allow marketing teams to reuse visual content efficiently.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
